module.exports = __webpack_public_path__ + "static/media/order_cycle.18fcd8ad.png";